<template>
  <main>
    <div class="py-12 md:px-12 lg:px-14 p-4 max-w-screen-2xl mx-auto bg-main">
      <div
        class="flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-52"
      >
        <!-- First Image -->
        <div class="lg:w-1/4 w-full flex justify-center">
          <img
            src="../assets/images/couple2.jpeg"
            alt="First Image"
            class="rounded-full object-cover w-40 h-40 lg:w-72 lg:h-72"
          />
        </div>

        <!-- Second Image -->
        <div class="lg:w-1/4 w-full flex justify-center mt-4 lg:mt-0">
          <img
            src="../assets/images/couple1.jpeg"
            alt="Second Image"
            class="rounded-full object-cover w-40 h-40 lg:w-72 lg:h-72"
          />
        </div>
      </div>

      <!-- Text Content (Centered) -->
      <div class="flex items-center justify-center mt-4 lg:-mt-28">
        <div class="lg:w-1/2 w-full">
          <div class="bg-white shadow p-6">
            <p class="mb-4">
              Behind every successful man is a woman from God; and behind every
              happy woman is a Godly Leader, Mentor, Investor, and a Husband.
              Sollicitudin tincidunt molestie senectus consectetur sagittis sit
              tortor imperdiet arcument.
            </p>
            <p class="mb-4">
              Consectetur pellentesque ullamcorper hendrerit dolor nisi sit,
              consectetur pellentesque ullamcorper hendrerit dolor nisi sit.
            </p>
            <p class="mb-4">
              Lorem ipsum dolor sit amet consectetur. Sollicitudin tincidunt
              molestie senectus consectetur sagittis sit tortor imperdiet arcu.
            </p>
            <p class="mb-4">
              Tellus dapibus quis turpis phasellus nisi praesent magna. Habitant
              fames lobortis eu fusce hendrerit egestas eu proin suspendisse.
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
